import BaseEnum from "./base_enum.js";

class InvestmentStatusEnumDesc extends BaseEnum {

  name() {
    return "investment_status";
  }

  rawValues() {
    return ["personal_info", "questionnaire", "payment_method", "information_emailed", "confirmation", "applied", "paid", "paid_back"];
  }

  completedValues() {
    return ["applied", "paid", "paid_back"];
  }

  notCompletedValues() {
    return ["personal_info", "questionnaire", "payment_method", "information_emailed", "confirmation"];
  }

  paidValues() {
    return ["paid", "paid_back"];
  }

  unpaidValues() {
    return ["applied"];
  }
}

const InvestmentStatusEnum = new InvestmentStatusEnumDesc();
export default InvestmentStatusEnum;